import { featureFlagService } from '@superbet-group/web.lib.flags';
import { SuperbetRouteConfig } from '@superbet-group/web.types';
import { omit } from 'lodash';

import { Product } from '@app/router/products/Product';
import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { defaultLayout } from '@app/router/utils';
import CalendarGamePage from '@modules/calendarGame/CalendarGamePage.vue';
import { Theme } from '@superbet-group/web.lib.ui-components';

export const calendarGameRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.Free2Play.CalendarGame,
        name: RouteName.Free2Play.CalendarGame,
        isAccessible: Product.Free2Play.CalendarGame,
        components: omit({
            content: CalendarGamePage,
            ...defaultLayout,
        }, ['tickets']),
        meta: {
            layoutClass: 'calendar-game',
            forcedTheme: Theme.Dark,
        },
        async beforeEnter(to, from, next) {
            const isCalendarGameEnabled = await featureFlagService.getFeatureValue('free-to-play.calendar-game-enabled', false);

            if (isCalendarGameEnabled) {
                next();
                return;
            }
            next({ name: RouteName.App.NotFound });
        },
    },
];
